import './informations';
import './informations-list';
import './informations-edit'; 